"use strict";

var _interopRequireDefault = require("C:/Users/sandy/Desktop/EIOSYS/Admin/Alembic-Grow-Admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _interopRequireWildcard2 = _interopRequireDefault(require("C:/Users/sandy/Desktop/EIOSYS/Admin/Alembic-Grow-Admin/node_modules/@babel/runtime/helpers/interopRequireWildcard.js"));
var _index = _interopRequireDefault(require("@/layout/index.vue"));
const scoresRouter = {
  path: '/scores',
  component: _index.default,
  redirect: 'scores',
  name: 'scores',
  meta: {
    title: 'scores.title',
    icon: 'edit'
  },
  children: [{
    path: 'list',
    component: () => Promise.resolve().then(() => (0, _interopRequireWildcard2.default)(require( /* webpackChunkName: "admins-list" */'@/views/scores/list.vue'))),
    name: 'scores',
    meta: {
      title: 'scores.title',
      noCache: true,
      icon: 'edit'
    }
  }]
};
var _default = exports.default = scoresRouter;